/* NIDO Passo — comportamento pagina prodotto (senza MutationObserver) */
(function () {
  if (window.__npsInit) return;
  window.__npsInit = true;

  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  ready(function () {
    var data = { variants: [] };
    try { data = JSON.parse(document.getElementById('nps-data').textContent); } catch (e) {}
    var variants = data.variants || [];

    function currentVariant() {
      var r = document.querySelector('variant-selects input[type="radio"]:checked');
      var val = r ? r.value : null;
      if (!val) { var s = document.querySelector('variant-selects select'); if (s) val = s.value; }
      for (var i = 0; i < variants.length; i++) if (variants[i].o1 === val) return variants[i];
      var idIn = document.querySelector('product-form input[name="id"]');
      if (idIn) for (var j = 0; j < variants.length; j++) if (String(variants[j].id) === String(idIn.value)) return variants[j];
      return variants[0] || null;
    }
    function priceHTML(v) { if (!v) return ''; return (v.cmp ? '<s>' + v.cmp + '</s> ' : '') + v.p; }
    function mainBtn() { return document.querySelector('product-form .product-form__submit'); }

    /* bottone principale con prezzo */
    function labelBtn() {
      var btn = mainBtn(); if (!btn) return;
      var span = btn.querySelector('span'); if (!span) return;
      if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
      var v = currentVariant(); if (!v) return;
      if (span.getAttribute('data-nps-v') === String(v.id) && span.querySelector('.nps-bp')) return;
      span.innerHTML = (data.atc || 'Aggiungi al carrello') + ' <span class="nps-bp">– ' + priceHTML(v) + '</span>';
      span.setAttribute('data-nps-v', String(v.id));
    }

    /* card colori */
    function syncCards() {
      var v = currentVariant(); if (!v) return;
      var cards = document.querySelectorAll('.nps-color');
      for (var i = 0; i < cards.length; i++) {
        var on = cards[i].getAttribute('data-value') === v.o1;
        if (cards[i].classList.contains('is-on') !== on) cards[i].classList.toggle('is-on', on);
        cards[i].setAttribute('aria-pressed', on ? 'true' : 'false');
      }
    }

    /* galleria: etichette + fascia icone */
    function decorateGallery() {
      var g = document.querySelector('media-gallery'); if (!g) return;
      var tb = document.getElementById('nps-tpl-badges');
      if (tb) {
        var cs = g.querySelectorAll('.product__media-item .product-media-container');
        for (var i = 0; i < cs.length; i++) {
          if (cs[i].querySelector('.nps-gb')) continue;
          var d = document.createElement('div'); d.className = 'nps-gb'; d.innerHTML = tb.innerHTML; cs[i].appendChild(d);
        }
      }
      var te = document.getElementById('nps-tpl-emblems');
      var viewer = g.querySelector('[id^="GalleryViewer"]');
      if (te && viewer && !g.querySelector('.nps-emblems')) viewer.insertAdjacentHTML('afterend', te.innerHTML);
    }

    function refresh() {
      syncCards();
      var v = currentVariant(); if (!v) return;
      labelBtn();
      var els = document.querySelectorAll('[data-nps-price]');
      for (var i = 0; i < els.length; i++) els[i].innerHTML = (v.cmp ? '<s>' + v.cmp + '</s> ' : '') + '<b>' + v.p + '</b>';
      var bps = document.querySelectorAll('[data-nps-btnprice]');
      for (var j = 0; j < bps.length; j++) bps[j].innerHTML = priceHTML(v);
      var sImg = document.querySelector('.nps-sticky__img img');
      if (sImg && v.img && sImg.getAttribute('src') !== v.img) { sImg.removeAttribute('srcset'); sImg.src = v.img; }
      decorateGallery();
    }
    function refreshSoon() { [60, 500, 1200, 2500].forEach(function (t) { setTimeout(refresh, t); }); }

    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      var b = e.target.closest('.nps-color');
      if (b) {
        var val = b.getAttribute('data-value');
        var inputs = document.querySelectorAll('variant-selects input[type="radio"]');
        for (var i = 0; i < inputs.length; i++) {
          if (inputs[i].value === val) { if (!inputs[i].checked) inputs[i].click(); break; }
        }
        var sel = document.querySelector('variant-selects select');
        if (sel && sel.value !== val) { sel.value = val; sel.dispatchEvent(new Event('change', { bubbles: true })); }
        var cards = document.querySelectorAll('.nps-color');
        for (var k = 0; k < cards.length; k++) cards[k].classList.toggle('is-on', cards[k] === b);
        refreshSoon();
        return;
      }
      var a = e.target.closest('[data-nps-go]');
      if (a) {
        var el = document.querySelector(a.getAttribute('data-nps-go')) || document.querySelector('product-form');
        if (!el) return;
        e.preventDefault();
        if (el.tagName === 'DETAILS') el.open = true;
        window.scrollTo({ top: el.getBoundingClientRect().top + window.pageYOffset - 120, behavior: 'smooth' });
      }
    });
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('variant-selects')) refreshSoon();
    });

    /* date di consegna (8-10 giorni lavorativi) */
    var M = ['gen', 'feb', 'mar', 'apr', 'mag', 'giu', 'lug', 'ago', 'set', 'ott', 'nov', 'dic'];
    function addBiz(n) { var d = new Date(); var guard = 0; while (n > 0 && guard < 60) { guard++; d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n--; } return d; }
    function f(d) { return d.getDate() + ' ' + M[d.getMonth()]; }
    var etas = document.querySelectorAll('[data-nps-eta]');
    for (var q = 0; q < etas.length; q++) etas[q].textContent = 'tra il ' + f(addBiz(8)) + ' e il ' + f(addBiz(10));

    /* video */
    var nexts = document.querySelectorAll('[data-nps-next]');
    for (var n = 0; n < nexts.length; n++) nexts[n].addEventListener('click', function () {
      var t = this.parentNode.querySelector('[data-nps-track]');
      if (t) t.scrollBy({ left: t.clientWidth * 0.8, behavior: 'smooth' });
    });
    var cardsV = document.querySelectorAll('.nps-vid');
    for (var c = 0; c < cardsV.length; c++) (function (card) {
      var v = card.querySelector('video'); if (!v) return;
      v.muted = true; v.setAttribute('playsinline', ''); v.removeAttribute('controls');
      card.addEventListener('click', function () {
        if (v.paused) { v.play(); card.classList.add('is-playing'); }
        else if (v.muted) { v.muted = false; }
        else { v.pause(); card.classList.remove('is-playing'); }
      });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          if (en[0].isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); card.classList.add('is-playing'); }
          else { v.pause(); card.classList.remove('is-playing'); }
        }, { threshold: 0.6 }).observe(card);
      }
    })(cardsV[c]);

    /* barra sticky */
    var sticky = document.querySelector('.nps-sticky');
    if (sticky && !(window.Shopify && Shopify.designMode)) {
      document.body.appendChild(sticky);
    }
    if (sticky) {
      var sb = sticky.querySelector('.nps-sticky__btn');
      if (sb) sb.addEventListener('click', function () { var b = mainBtn(); if (b) b.click(); });
      var target = document.querySelector('product-form') || mainBtn();
      if (target && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          sticky.classList.toggle('is-on', !en[0].isIntersecting && en[0].boundingClientRect.top < 0);
        }).observe(target);
      }
    }

    refresh();
    setTimeout(refresh, 800);
  });
})();